import { TemplateRef } from '@angular/core';
import { SessionService } from '../../../session/session.service';
import { MessageService } from '../../../message/message.service';
import { QuestionarreAnswerService } from '../../../questionarre-answer/questionarre-answer.service';
import { ActivatedRoute, Router } from "@angular/router";
import { SessionStorageService } from "ngx-webstorage";
import { TrackerService } from '../../../../core/tracker/tracker.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { JhiAlertService, JhiEventManager } from '../../../../ng-jhipster/service';
import { TranslateService } from "@ngx-translate/core";
import { VideoCallService } from '../../../video-call/video-call.service';
import { ZoomService } from '../../../video-call/zoom.service';
import { AccountService } from '../../../../core/auth/account.service';
import { BaseComponent } from '../../../../shared/base.component';
import { ActionPlanService } from '../../../action-plan/action-plan.service';
import { TranscriptionStatusUpdatedPopupComponent } from '../../../video-call/transcription-status-updated-popup/transcription-status-updated-popup.component';
import * as i0 from "@angular/core";
import * as i1 from "../../../session/session.service";
import * as i2 from "../../../message/message.service";
import * as i3 from "../../../questionarre-answer/questionarre-answer.service";
import * as i4 from "@angular/router";
import * as i5 from "ngx-webstorage";
import * as i6 from "../../../../core/tracker/tracker.service";
import * as i7 from "@ng-bootstrap/ng-bootstrap";
import * as i8 from "../../../../ng-jhipster/service";
import * as i9 from "@ngx-translate/core";
import * as i10 from "../../../video-call/video-call.service";
import * as i11 from "../../../video-call/zoom.service";
import * as i12 from "../../../../core/auth/account.service";
import * as i13 from "../../../action-plan/action-plan.service";
import * as i14 from "@angular/common";
import * as i15 from "../../../video-call/join-video-call/join-video-call.component";
import * as i16 from "../../../video-call/user-session-control/user-session-control.component";
import * as i17 from "../../../video-call/zoom-call/zoom-call.component";
import * as i18 from "@fortawesome/angular-fontawesome";
import * as i19 from "../../../../ng-jhipster/language/jhi-translate.directive";
import * as i20 from "../../chat-ui/message-send/session-message-send.component";
import * as i21 from "../../../video-call/user-session-control/user-session-control-upper-mobile.component";
import * as i22 from "../../chat-ui-new/chat-ui-new.component";
import * as i23 from "../../../action-plan/action-plan/action-plan.component";
import * as i24 from "../../../video-call/user-session-control/user-session-control-lower-mobile.component";
function VideoSessionUserComponent_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵelementStart(2, "join-video-call", 6);
    i0.ɵɵlistener("onJoinCallClick", function VideoSessionUserComponent_div_0_ng_container_3_Template_join_video_call_onJoinCallClick_2_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(2); return ctx_r4.joinVideoCall(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("session", ctx_r2.session);
} }
function VideoSessionUserComponent_div_0_ng_container_4_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵelementStart(1, "user-session-control-upper-mobile", 46);
    i0.ɵɵlistener("displayUserPanel", function VideoSessionUserComponent_div_0_ng_container_4_div_5_Template_user_session_control_upper_mobile_displayUserPanel_1_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(3); return ctx_r20.toggleRightSidebar(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("session", ctx_r7.session)("isUserPanelOn", ctx_r7.showRightSidebar)("showUnreadIndicator", ctx_r7.showUnreadIndicator);
} }
function VideoSessionUserComponent_div_0_ng_container_4_chat_ui_new_30_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "chat-ui-new", 47);
    i0.ɵɵlistener("unreadMessageCountChange", function VideoSessionUserComponent_div_0_ng_container_4_chat_ui_new_30_Template_chat_ui_new_unreadMessageCountChange_0_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(3); return ctx_r22.updateUnreadMessageCount($event); })("repliedMessage", function VideoSessionUserComponent_div_0_ng_container_4_chat_ui_new_30_Template_chat_ui_new_repliedMessage_0_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r24 = i0.ɵɵnextContext(3); return ctx_r24.repliedMessage($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("viewportHeight", "100%")("session", ctx_r12.session)("displayingPastSession", false);
} }
function VideoSessionUserComponent_div_0_ng_container_4_chat_ui_new_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "chat-ui-new", 48);
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("viewportHeight", "100%")("session", ctx_r15.session)("displayingPastSession", false);
} }
function VideoSessionUserComponent_div_0_ng_container_4_div_42_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 49);
    i0.ɵɵelementStart(1, "div", 50);
    i0.ɵɵelementStart(2, "div", 51);
    i0.ɵɵelement(3, "action-plan", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("actionPlan", ctx_r17.actionPlan);
} }
function VideoSessionUserComponent_div_0_ng_container_4_user_session_control_lower_mobile_45_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "user-session-control-lower-mobile", 53);
    i0.ɵɵlistener("onLeaveCall", function VideoSessionUserComponent_div_0_ng_container_4_user_session_control_lower_mobile_45_Template_user_session_control_lower_mobile_onLeaveCall_0_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(3); return ctx_r25.leaveVideoCall(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("session", ctx_r19.session);
} }
const _c0 = function (a0) { return { "max-height": a0 }; };
const _c1 = function (a0) { return { "d-none d-lg-flex": a0 }; };
const _c2 = function (a0, a1) { return { "max-width": a0, "max-height": a1 }; };
const _c3 = function (a0) { return { "bg-success viewModeButtonActive": a0 }; };
const _c4 = function (a0) { return { height: a0 }; };
function VideoSessionUserComponent_div_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", null, 7);
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵelementStart(4, "user-session-control", 9);
    i0.ɵɵlistener("displayUserPanel", function VideoSessionUserComponent_div_0_ng_container_4_Template_user_session_control_displayUserPanel_4_listener() { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(2); return ctx_r27.toggleRightSidebar(); })("onLeaveCall", function VideoSessionUserComponent_div_0_ng_container_4_Template_user_session_control_onLeaveCall_4_listener() { i0.ɵɵrestoreView(_r28); const ctx_r29 = i0.ɵɵnextContext(2); return ctx_r29.leaveVideoCall(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, VideoSessionUserComponent_div_0_ng_container_4_div_5_Template, 2, 3, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 11, 12);
    i0.ɵɵelementStart(8, "div", 13, 14);
    i0.ɵɵelement(10, "zoom-call", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 16, 17);
    i0.ɵɵelementStart(13, "div", 18);
    i0.ɵɵelementStart(14, "div", 19);
    i0.ɵɵelementStart(15, "h4");
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 20);
    i0.ɵɵelementStart(18, "a", 21);
    i0.ɵɵlistener("click", function VideoSessionUserComponent_div_0_ng_container_4_Template_a_click_18_listener() { i0.ɵɵrestoreView(_r28); const ctx_r30 = i0.ɵɵnextContext(2); return ctx_r30.toggleRightSidebar(); });
    i0.ɵɵelement(19, "fa-icon", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 23);
    i0.ɵɵelementStart(21, "div", 24);
    i0.ɵɵlistener("click", function VideoSessionUserComponent_div_0_ng_container_4_Template_div_click_21_listener() { i0.ɵɵrestoreView(_r28); const ctx_r31 = i0.ɵɵnextContext(2); return ctx_r31.switchViewMode("Chat"); });
    i0.ɵɵelement(22, "h4", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 26);
    i0.ɵɵlistener("click", function VideoSessionUserComponent_div_0_ng_container_4_Template_div_click_23_listener() { i0.ɵɵrestoreView(_r28); const ctx_r32 = i0.ɵɵnextContext(2); return ctx_r32.switchViewMode("ActionPlan"); });
    i0.ɵɵelement(24, "h4", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 28);
    i0.ɵɵlistener("click", function VideoSessionUserComponent_div_0_ng_container_4_Template_div_click_25_listener() { i0.ɵɵrestoreView(_r28); const ctx_r33 = i0.ɵɵnextContext(2); return ctx_r33.switchViewMode("Transcript"); });
    i0.ɵɵelement(26, "h4", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 30, 31);
    i0.ɵɵelementStart(29, "div", 32);
    i0.ɵɵtemplate(30, VideoSessionUserComponent_div_0_ng_container_4_chat_ui_new_30_Template, 1, 3, "chat-ui-new", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "div", null, 34);
    i0.ɵɵelement(33, "session-message-send", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 30, 36);
    i0.ɵɵelementStart(36, "div", 32);
    i0.ɵɵtemplate(37, VideoSessionUserComponent_div_0_ng_container_4_chat_ui_new_37_Template, 1, 3, "chat-ui-new", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "div", 38, 39);
    i0.ɵɵelementStart(40, "span", 40);
    i0.ɵɵtext(41, "Your coach turned off the transcription");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(42, VideoSessionUserComponent_div_0_ng_container_4_div_42_Template, 4, 1, "div", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(43, "div", 42, 43);
    i0.ɵɵtemplate(45, VideoSessionUserComponent_div_0_ng_container_4_user_session_control_lower_mobile_45_Template, 1, 1, "user-session-control-lower-mobile", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r6 = i0.ɵɵreference(2);
    const _r8 = i0.ɵɵreference(7);
    const _r9 = i0.ɵɵreference(9);
    const _r11 = i0.ɵɵreference(28);
    const _r13 = i0.ɵɵreference(32);
    const _r14 = i0.ɵɵreference(35);
    const _r16 = i0.ɵɵreference(39);
    const _r18 = i0.ɵɵreference(44);
    i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(2);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("session", ctx_r3.session)("isUserPanelOn", ctx_r3.showRightSidebar)("showUnreadIndicator", ctx_r3.showUnreadIndicator);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.showBars);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(31, _c0, _r1.offsetHeight - (_r6.offsetHeight + _r18.offsetHeight + 60) + "px"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(33, _c1, ctx_r3.showRightSidebar))("ngStyle", i0.ɵɵpureFunction2(35, _c2, ctx_r3.showRightSidebar && ctx_r3.isScreenLg ? ctx_r3.windowWidth * 0.75 + "px" : "unset", _r8.offsetHeight + "px"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("session", ctx_r3.session)("height", _r9.offsetHeight)("participantUser", ctx_r3.session.coach)("selfUser", ctx_r3.session.user);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r3.showRightSidebar ? "d-flex flex-column" : "d-none")("ngStyle", i0.ɵɵpureFunction1(38, _c0, _r8.offsetHeight + "px"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r3.coach.login);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(40, _c3, ctx_r3.viewMode === "Chat"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(42, _c3, ctx_r3.viewMode === "ActionPlan"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(44, _c3, ctx_r3.viewMode === "Transcript"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r3.viewMode === "Chat" ? "d-flex flex-column" : "d-none");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(46, _c4, _r11.offsetHeight - _r13.offsetHeight - 50 + "px"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.session);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("session", ctx_r3.session)("message", ctx_r3.message)("maxCharacterSize", 3000)("messageToBeReplied", ctx_r3.messageToBeReplied);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r3.viewMode === "Transcript" ? "d-flex flex-column" : "d-none");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(48, _c4, _r14.offsetHeight - _r16.offsetHeight - 50 + "px"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.session);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("d-none", ctx_r3.isTranscriptionEnabled);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r3.viewMode == "ActionPlan" && ctx_r3.session);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r3.showBars);
} }
function VideoSessionUserComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("click", function VideoSessionUserComponent_div_0_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(); return ctx_r34.onClick(); });
    i0.ɵɵelementStart(1, "div", 2, 3);
    i0.ɵɵtemplate(3, VideoSessionUserComponent_div_0_ng_container_3_Template, 3, 1, "ng-container", 4);
    i0.ɵɵtemplate(4, VideoSessionUserComponent_div_0_ng_container_4_Template, 46, 50, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.view === "PREVIEW");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.view === "JOINED");
} }
export class VideoSessionUserComponent extends BaseComponent {
    constructor(sessionService, messageService, questionarreAnswerService, route, sessionStorage, trackerService, modalService, alertService, translate, eventManager, router, videoCallService, zoomService, accountService, actionPlanService) {
        super(sessionStorage, modalService);
        this.sessionService = sessionService;
        this.messageService = messageService;
        this.questionarreAnswerService = questionarreAnswerService;
        this.route = route;
        this.sessionStorage = sessionStorage;
        this.trackerService = trackerService;
        this.modalService = modalService;
        this.alertService = alertService;
        this.translate = translate;
        this.eventManager = eventManager;
        this.router = router;
        this.videoCallService = videoCallService;
        this.zoomService = zoomService;
        this.accountService = accountService;
        this.actionPlanService = actionPlanService;
        this.view = 'PREVIEW';
        this.viewMode = 'Chat';
        this.showRightSidebar = true;
        this.message = '';
        this.showBars = true;
    }
    ngOnDestroy() {
        var _a, _b;
        (_a = this.onVideoCallEndedSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.listenerObjectSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        this.zoomService.destroy();
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.showRightSidebar = this.isScreenLg;
    }
    ngOnInit() {
        const sessionIdFromUrl = this.route.snapshot.params["sessionId"];
        // get current session and coach data
        // get past messages
        this.messageService.getSession(sessionIdFromUrl).subscribe((res1) => {
            this.onSuccess(res1.body);
        }, err => this.onError(err));
        this.subscribeToWebsocket();
    }
    startTimer() {
        if (this.timeHandler) {
            clearTimeout(this.timeHandler);
        }
        this.timeHandler = setTimeout(() => {
            this.showBars = false;
        }, 10000);
    }
    subscribeToWebsocket() {
        this.listenerObjectSubscription = this.trackerService.listenerSubject.subscribe(value => {
            var _a;
            const message = value['body'];
            const type = value['type'];
            if (type === 'SESSION_STATUS_CHANGED') {
                let s = message;
                if (this.session.id === s.id) {
                    this.messageService.getSession(this.session.id).subscribe((res1) => {
                        this.onSuccess(res1.body);
                    });
                    // this.open(this.sessionEndedModal);
                }
            }
            else if (type === 'WELLBEING_PLAN_UPDATED') {
                this.hasUnseenActionPlan = true;
                this.updateUnreadIndicator();
                this.fetchActiveActionPlan();
            }
            else if (type === 'SESSION_EXTENDED') {
                this.session.duration = message['duration'];
                // this.updateMinutesLeft();
            }
            else if (type === 'VIDEO_CALL_STARTED') {
                let s = message;
                if ((s === null || s === void 0 ? void 0 : s.id) === ((_a = this.session) === null || _a === void 0 ? void 0 : _a.id)) {
                    // coach initiated a video call
                    this.router.navigate(['/session/video', this.session.id]).then();
                }
            }
            else if (type === 'VIDEO_CALL_TRANSCRIPTION_STATUS_UPDATED') {
                let transcriptionEnabled = message;
                if (this.isTranscriptionEnabled !== transcriptionEnabled) {
                    this.isTranscriptionEnabled = transcriptionEnabled;
                    this.showTranscriptionStatusUpdatedPopup();
                }
            }
            else if (type === 'SESSION_LANGUAGE_UPDATED') {
                let s = message;
                if (s.id === this.session.id) {
                    this.messageService.getSession(this.session.id).subscribe((res1) => {
                        this.session = res1.body;
                        this.zoomService.switchLanguage(s.langKey);
                    });
                }
            }
            else {
                // console.log('SessionChatUserComponent ignoring ' + type + ' message');
            }
        });
    }
    joinVideoCall() {
        const userLogin = this.accountService.getCurrentLoggedInUser().login;
        this.videoCallService.joinVideoCall(this.session).subscribe(videoCallJoinInfo => {
            this.isTranscriptionEnabled = videoCallJoinInfo.body.transcriptionEnabled;
            this.zoomService.joinVideoCall(userLogin, videoCallJoinInfo.body).subscribe(() => {
                this.onJoinedToVideoCall();
            });
        }, error => {
            this.redirectToSessionChat();
        });
    }
    fetchActiveActionPlan() {
        this.actionPlanService.findBySessionId(this.session.id).subscribe((res) => {
            this.actionPlan = res.body;
        }, err => console.log(err.message));
    }
    onJoinedToVideoCall() {
        this.view = 'JOINED';
        this.startTimer();
        if (!this.onVideoCallEndedSubscription) {
            this.onVideoCallEndedSubscription = this.zoomService.onVideoCallEnded$().subscribe(() => {
                this.redirectToSessionChat();
            });
        }
    }
    onSuccess(body) {
        this.session = body;
        if (this.session.ended) {
            this.redirectToSessionChat();
            return;
        }
        this.coach = this.session.coach;
        this.fetchActiveActionPlan();
        // this.updateMinutesLeftRecurring(2);
    }
    onError(err) {
        console.log('error occured: ' + JSON.stringify(err.status));
        if (err.status === 404) {
            // this.modalService.open(this.sessionDoesNotExistModal);
        }
    }
    leaveVideoCall() {
        this.zoomService.leaveVideoCall().subscribe(() => {
        });
    }
    redirectToSessionChat() {
        this.router.navigate(['/session/chat', this.session.id]).then();
    }
    switchViewMode(newMode) {
        this.viewMode = newMode;
        if (this.viewMode === 'ActionPlan') {
            this.hasUnseenActionPlan = false;
        }
        if (this.viewMode === 'Chat' || this.viewMode === 'Transcript') {
            this.updateChatUiComponentSize();
        }
        this.updateUnreadIndicator();
    }
    updateChatUiComponentSize() {
        this.eventManager.broadcast('update-chat-ui-component-size');
    }
    toggleRightSidebar() {
        this.showRightSidebar = !this.showRightSidebar;
        if (this.showRightSidebar) {
            this.updateChatUiComponentSize();
        }
    }
    goToLink(link) {
        window.open(link, '_blank');
    }
    repliedMessage(message) {
        this.messageToBeReplied = message;
        console.log(this.messageToBeReplied);
    }
    open(content) {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(result => {
            this.closeResult = `Closed with: ${result}`;
        }, reason => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }
    onClick() {
        this.showBars = true;
        this.startTimer();
    }
    updateUnreadMessageCount(count) {
        this.unreadMessageCount = count;
        this.updateUnreadIndicator();
    }
    updateUnreadIndicator() {
        if (!this.showRightSidebar && (this.unreadMessageCount > 0 || this.hasUnseenActionPlan)) {
            this.showUnreadIndicator = true;
        }
        else {
            this.showUnreadIndicator = false;
        }
    }
    showTranscriptionStatusUpdatedPopup() {
        const modalRef = this.modalService.open(TranscriptionStatusUpdatedPopupComponent, { size: 'md', centered: true });
        modalRef.componentInstance.isTranscriptionEnabled = this.isTranscriptionEnabled;
    }
}
VideoSessionUserComponent.ɵfac = function VideoSessionUserComponent_Factory(t) { return new (t || VideoSessionUserComponent)(i0.ɵɵdirectiveInject(i1.SessionService), i0.ɵɵdirectiveInject(i2.MessageService), i0.ɵɵdirectiveInject(i3.QuestionarreAnswerService), i0.ɵɵdirectiveInject(i4.ActivatedRoute), i0.ɵɵdirectiveInject(i5.SessionStorageService), i0.ɵɵdirectiveInject(i6.TrackerService), i0.ɵɵdirectiveInject(i7.NgbModal), i0.ɵɵdirectiveInject(i8.JhiAlertService), i0.ɵɵdirectiveInject(i9.TranslateService), i0.ɵɵdirectiveInject(i8.JhiEventManager), i0.ɵɵdirectiveInject(i4.Router), i0.ɵɵdirectiveInject(i10.VideoCallService), i0.ɵɵdirectiveInject(i11.ZoomService), i0.ɵɵdirectiveInject(i12.AccountService), i0.ɵɵdirectiveInject(i13.ActionPlanService)); };
VideoSessionUserComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: VideoSessionUserComponent, selectors: [["video-session-user"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "olha-theme", 3, "click", 4, "ngIf"], [1, "olha-theme", 3, "click"], [1, "user-session-video-container", "d-flex", "flex-column", "justify-content-center"], ["coachSessionVideoContainer", ""], [4, "ngIf"], [1, "video-call-preview-container", "d-flex", "justify-content-center", "flex-grow-1"], [3, "session", "onJoinCallClick"], ["headerContainer", ""], [1, "d-none", "d-lg-flex"], [2, "width", "100%", 3, "session", "isUserPanelOn", "showUnreadIndicator", "displayUserPanel", "onLeaveCall"], ["class", "d-flex d-lg-none", 4, "ngIf"], [1, "main-container", "flex-grow-1", "d-lg-flex", 3, "ngStyle"], ["mainContainer", ""], [1, "zoom-call-container", 3, "ngClass", "ngStyle"], ["zoomCallContainer", ""], [2, "width", "100%", 3, "session", "height", "participantUser", "selfUser"], [1, "right-sidebar", 3, "ngClass", "ngStyle"], ["rightSidebarContainer", ""], [1, "row", "m-0", "p-3", "justify-content-around", "align-items-center"], [1, "col", "pl-2"], [1, "col", "p-0", "text-right"], [3, "click"], ["icon", "times-circle", 1, "mt-3", "mr-3", 2, "cursor", "pointer"], [1, "row", "m-0", "text-center"], [1, "col", "px-2", "py-3", "pointer", "border", "border-primary", "border-left-0", "border-right-0", "rounded-0", 3, "ngClass", "click"], ["jhiTranslate", "sessionChat.button.chat", 1, "mb-0", "w-100", "text-center", "font-weight-bold"], [1, "col", "px-2", "py-3", "pointer", "border", "border-primary", "border-right-0", "rounded-0", 3, "ngClass", "click"], ["jhiTranslate", "sessionChat.button.actionPlan", 1, "mb-0", "w-100", "text-center", "font-weight-bold"], [1, "col", "px-2", "py-3", "pointer", "border", "border-primary", "rounded-0", 3, "ngClass", "click"], ["jhiTranslate", "sessionChat.button.transcript", 1, "mb-0", "w-100", "text-center", "font-weight-bold"], [1, "view-mode-parent", "flex-grow-1", 3, "ngClass"], ["chatContainer", ""], [1, "chat-container-coach", "p-1", "flex-grow-1", 3, "ngStyle"], ["style", "height: 100%", 3, "viewportHeight", "session", "displayingPastSession", "unreadMessageCountChange", "repliedMessage", 4, "ngIf"], ["messageSendContainer", ""], [3, "session", "message", "maxCharacterSize", "messageToBeReplied"], ["transcriptContainer", ""], ["displayTranscriptions", "true", "isMessageReactionsEnabled", "false", 3, "viewportHeight", "session", "displayingPastSession", 4, "ngIf"], [1, "transcription-status", "py-3", "text-center"], ["transcriptionStatusContainer", ""], ["jhiTranslate", "sessionChat.coachSessionControl.transcriptionIsTurnedOff"], ["class", "p-1", "style", "position: relative; flex: 1 1 0;", 4, "ngIf"], [1, "d-block", "d-lg-none"], ["footerContainer", ""], [3, "session", "onLeaveCall", 4, "ngIf"], [1, "d-flex", "d-lg-none"], [2, "width", "100%", 3, "session", "isUserPanelOn", "showUnreadIndicator", "displayUserPanel"], [2, "height", "100%", 3, "viewportHeight", "session", "displayingPastSession", "unreadMessageCountChange", "repliedMessage"], ["displayTranscriptions", "true", "isMessageReactionsEnabled", "false", 3, "viewportHeight", "session", "displayingPastSession"], [1, "p-1", 2, "position", "relative", "flex", "1 1 0"], [2, "position", "absolute", "right", "0", "left", "0", "display", "flex", "flex-direction", "column", "height", "100%"], [1, "flex-grow-1", "py-3", 2, "overflow-y", "scroll", "overflow-x", "hidden"], ["showAll", "true", 3, "actionPlan"], [3, "session", "onLeaveCall"]], template: function VideoSessionUserComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, VideoSessionUserComponent_div_0_Template, 5, 2, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.session);
    } }, directives: [i14.NgIf, i15.JoinVideoCallComponent, i16.UserSessionControlComponent, i14.NgStyle, i14.NgClass, i17.ZoomCallComponent, i18.FaIconComponent, i19.JhiTranslateDirective, i20.SessionMessageSendComponent, i21.UserSessionControlUpperMobileComponent, i22.ChatUiNewComponent, i23.ActionPlanComponent, i24.UserSessionControlLowerMobileComponent], styles: [".user-session-video-container[_ngcontent-%COMP%]{height:100vh;padding-top:60px;overflow:hidden}.video-call-preview-container[_ngcontent-%COMP%]{background-color:#0a4a3a}.zoom-call-container[_ngcontent-%COMP%]{overflow:hidden;flex-grow:1;height:100%}.zoom-call-container[_ngcontent-%COMP%]   *[_ngcontent-%COMP%] > {width:100%}.main-container[_ngcontent-%COMP%]{position:relative}.right-sidebar[_ngcontent-%COMP%]{z-index:1;background-color:#fff;overflow:hidden;height:100%}.viewModeButtonActive[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{color:#fff}.transcription-status[_ngcontent-%COMP%]{background-color:var(--bg-1);font-size:16px;font-weight:400}@media(min-width: 1200px){.user-session-video-container[_ngcontent-%COMP%]{padding-top:60px}.right-sidebar[_ngcontent-%COMP%]{width:25%}}"] });
